import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCapture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCapture"><Path d="M8.5 20.5H3.5V15.5M15.5 20.5H20.5V15.5M3.5 8.5V3.5H8.5M15.5 3.5H20.5V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 15.5V8.5H9.75L10.75 7.5H13.25L14.25 8.5H16.5V15.5H7.5Z" stroke="currentColor"/><Path d="M13.5 11.9C13.5 12.7285 12.8284 13.4 12 13.4C11.1716 13.4 10.5 12.7285 10.5 11.9C10.5 11.0716 11.1716 10.4 12 10.4C12.8284 10.4 13.5 11.0716 13.5 11.9Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCapture;
